import { REGISTER_CHANGE } from "./actionTypes";

// eslint-disable-next-line 
export default (state = {}, action) => {
  switch (action.type) {
    case REGISTER_CHANGE:
      return action.payload;
    default:
      return state;
  }
};
